import { utils, write } from 'xlsx';

import { formatObjectKeysToReadable } from './FormattingHelpers';

const downloadFile = (
    contents: Blob | string,
    fileName: string,
    mimeType: string = 'text/csv;charset=utf-8;'
): { success: boolean; error?: string } => {
    if (!contents) {
        return { success: false, error: 'No contents to download' };
    }

    try {
        const blob = contents instanceof Blob ? contents : new Blob([contents], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);

        return { success: true };
    } catch (err) {
        console.error('Download failed:', err);
        return { success: false, error: err instanceof Error ? err.message : 'Unknown file download error' };
    }
};

export const downloadExcelFromObjects = (
    data: Array<Record<string, unknown>>,
    fileName = 'data.xlsx',
    sheetName = 'Sheet1'
): { success: boolean; error?: string } => {
    if (!Array.isArray(data) || typeof data[0] !== 'object' || data[0] === null) {
        console.error('Invalid data format for Excel download');
        return { success: false, error: 'Invalid data format for Excel download' };
    }

    const transformedData = formatObjectKeysToReadable(data);
    const worksheet = utils.json_to_sheet(transformedData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, sheetName);

    // Get the workbook data as an ArrayBuffer
    const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });

    // Convert to Blob
    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    return downloadFile(blob, fileName);
};
